import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { SubscriptionPlan } from './useGetSubscriptionPlans';

export interface UserSubscription {
  id: string;
  userId: string;
  planId: string;
  startDate: string;
  endDate: string;
  isActive: boolean;
  cancellationDate: Date;
  remainingCredits: number;
  createdAt: string;
  updatedAt: string;
  plan?: SubscriptionPlan;
}

export interface GetAllSubscriptionsResponse {
  name: string;
  planId: string;
  planUniqueId: string;
  interval: string;
  isActive: boolean;
  totalCredits: number;
  remainingCredits: number;
  startDate: string;
  expiryDate: string;
  cancellationDate: Date;
  creditsExpiryDate: Date;
  isGhlSubscription: boolean;
  ghlSubscriptionId: string;
}
export const getActiveSubscriptions = async (): Promise<Array<GetAllSubscriptionsResponse>> => {
  const response = await axiosInstance.post('/api/users/all-subscriptions');
  return response.data;
};

export const useGetActiveSubscriptions = (enabled = true) => {
  return useQuery(['getActiveSubscriptions'], () => getActiveSubscriptions(), {
    enabled,
  });
};
